"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Components_1 = require("./Components");
var PackIdentifier_1 = require("../../../../Types/PackIdentifier");
var Components_2 = require("../../Components");
require("Utils/Extensions");
var BarcodeScannerHandler_1 = require("../../../../Services/BarcodeScannerHandler");
var EventHandlerService_1 = require("../../../../Services/EventHandlerService");
var Types_1 = require("../../../../Types");
var History_1 = require("../../../../Utils/History");
require("./Styles/Safe.css");
var SinglePackRequestService_1 = require("../../../../Services/SinglePackRequestService");
var Types_2 = require("../../Types");
var SignalR = require("@microsoft/signalr");
var Safe = /** @class */ (function (_super) {
    __extends(Safe, _super);
    function Safe(props) {
        var _this = _super.call(this, props) || this;
        _this.parsePackData = function (json) {
            var headers = new Headers();
            headers.append("content-type", "application/json;");
            fetch("/Parser/Parse", {
                headers: headers,
                method: "post",
                body: json
            })
                .then(function (response) {
                return response.json();
            }).then(function (result) {
                if (result.submit) {
                    _this.setState({
                        packIdentifier: result,
                        currentState: 3 /* Sending */
                    }, function () {
                        SinglePackRequestService_1.SinglePackRequestService.SubmitPackRequest(result, Types_2.PackAction.Verify, false, _this.props.applicationData.selectedLocation, _this.props.applicationData.resources).then(function (singlePackResult) {
                            _this.setState({
                                result: singlePackResult,
                                currentState: 4 /* Result */,
                                availableActions: singlePackResult.packActions
                            });
                        }).catch(function (err) {
                            console.error(err);
                            _this.setState({
                                currentState: 5 /* Error */,
                                availableActions: []
                            });
                        });
                    });
                }
                else {
                    console.error("Display error");
                    _this.setState({
                        result: {
                            packInfo: {
                                Warning: _this.props.applicationData.resources.CannotParseBarcode
                            },
                            ragClass: "Red"
                        },
                        currentState: 4 /* Result */,
                        availableActions: []
                    });
                }
            });
        };
        _this.actionButtonOnClick = function (action) {
            if (_this.state.currentState === 1 /* Scanning */ || _this.state.currentState === 3 /* Sending */) {
                return;
            }
            if (action.value == Types_2.PackAction.MarkAsDestroyed.value || action.value == Types_2.PackAction.MarkAsStolen.value) {
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.ActionCannotBeUndone(_this.props.applicationData.resources, function () {
                    _this.setState({
                        selectedAction: action,
                        currentState: 3 /* Sending */
                    }, function () {
                        SinglePackRequestService_1.SinglePackRequestService.SubmitPackRequest(_this.state.packIdentifier, _this.state.selectedAction, _this.state.manualEntry, _this.props.applicationData.selectedLocation, _this.props.applicationData.resources)
                            .then(function (singlePackResult) {
                            _this.setState({
                                result: singlePackResult,
                                currentState: 4 /* Result */,
                                availableActions: singlePackResult.packActions
                            });
                        })
                            .catch(function (err) {
                            console.error(err);
                            _this.setState({
                                currentState: 5 /* Error */,
                                availableActions: []
                            });
                        });
                    });
                }));
            }
            else {
                _this.setState({
                    selectedAction: action,
                    currentState: 3 /* Sending */
                }, function () {
                    SinglePackRequestService_1.SinglePackRequestService.SubmitPackRequest(_this.state.packIdentifier, _this.state.selectedAction, _this.state.manualEntry, _this.props.applicationData.selectedLocation, _this.props.applicationData.resources, _this.state.result)
                        .then(function (singlePackResult) {
                        _this.setState({
                            result: singlePackResult,
                            currentState: 4 /* Result */,
                            availableActions: singlePackResult.packActions
                        });
                    })
                        .catch(function (err) {
                        console.error(err);
                        _this.setState({
                            currentState: 5 /* Error */,
                            availableActions: []
                        });
                    });
                });
            }
        };
        _this.manualInputOnChangeHandler = function (e) {
            //console.log("manualInputOnChangeHandler");
            //console.log(`Updated ${e.currentTarget.name}: ${e.currentTarget.value}`);
            var newAvailableActions = _this.state.availableActions;
            var newPackIdentifier = _this.state.packIdentifier;
            newPackIdentifier[e.currentTarget.name] = e.currentTarget.value;
            //console.log("newPackIdentifier");
            //console.log(newPackIdentifier);
            if (!String.isNullOrWhitespace(newPackIdentifier.productCode) && !String.isNullOrWhitespace(newPackIdentifier.serialNumber)) {
                //console.log("Product Code and Serial Number are not null or whitepsace");
                if (Array.isNullOrEmpty(newAvailableActions)) {
                    //console.log("avaiableActions is null or empty");
                    newAvailableActions = [Types_2.PackAction.Verify];
                }
            }
            else {
                //console.log("Product Code and Serial Number are null or whitepsace");
                newAvailableActions = [];
            }
            newPackIdentifier.scheme = newPackIdentifier.productCode.length == 14 ? PackIdentifier_1.scheme.Gs1 : PackIdentifier_1.scheme.Ifa;
            _this.setState({
                currentState: 2 /* Typing */,
                packIdentifier: newPackIdentifier,
                availableActions: newAvailableActions
            });
        };
        _this.dataEntryModeToggleHandler = function () {
            if (_this.props.applicationData.calibrationData == null) {
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.NeedToCalibrateScannerWarningEvent(_this.props.applicationData.resources));
                return;
            }
            var manualEntry = _this.props.applicationData.apiProvider == "Ssr" ? !_this.state.manualEntry : false;
            _this.setState({
                manualEntry: manualEntry,
                currentState: 0 /* Waiting */,
                packIdentifier: new PackIdentifier_1.PackIdentifier(),
                availableActions: []
            });
        };
        if (_this.props.applicationData.userInfo.UserRole.match(/SuperUser/g)) {
            History_1.default.push('/Dashboard/Reports');
        }
        _this.barcodeScannerHandler = new BarcodeScannerHandler_1.BarcodeScannerHandler(_this.parseScannerInput.bind(_this));
        _this.scannedData = {};
        _this.state = {
            manualEntry: _this.props.applicationData.apiProvider == "Ssr" && _this.props.applicationData.calibrationData == null,
            availableActions: [],
            currentState: 0 /* Waiting */,
            packIdentifier: new PackIdentifier_1.PackIdentifier(),
            result: {},
            selectedAction: Types_2.PackAction.Verify
        };
        document.addEventListener("keypress", _this.barcodeScannerHandler.keyPressHandler, true);
        document.addEventListener("keydown", _this.barcodeScannerHandler.keyDownHandler, true);
        document.addEventListener("keyup", _this.barcodeScannerHandler.keyUpHandler, true);
        return _this;
    }
    Safe.prototype.componentWillUnmount = function () {
        document.removeEventListener("keypress", this.barcodeScannerHandler.keyPressHandler, true);
        document.removeEventListener("keydown", this.barcodeScannerHandler.keyDownHandler, true);
        document.removeEventListener("keyup", this.barcodeScannerHandler.keyUpHandler, true);
    };
    Safe.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.applicationData.selectedLocation != this.props.applicationData.selectedLocation) {
            this.setState({ manualEntry: this.props.applicationData.apiProvider == "Ssr" && this.props.applicationData.calibrationData == null });
        }
    };
    Safe.prototype.parseScannerInput = function (dom3KeyboardEventCodeSupport) {
        var _this = this;
        if (this.props.applicationData.connectionState != SignalR.HubConnectionState.Connected) {
            EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteWarningEvent(this.props.applicationData.resources.VeriLiteDisconnected));
            return;
        }
        if (this.state.currentState === 1 /* Scanning */ || this.state.currentState === 2 /* Typing */ || this.state.currentState === 3 /* Sending */) {
            return;
        }
        if (dom3KeyboardEventCodeSupport) {
            this.scannedData = this.barcodeScannerHandler.scannerInput.getInput();
        }
        else {
            this.scannedData = this.barcodeScannerHandler.scannerInput.getInputBytes();
        }
        var scannedString = String.fromCharCode.apply(String, this.scannedData);
        if (this.scannedData.length > 20) {
            if (this.props.applicationData.calibrationData == null) {
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.NeedToCalibrateScannerWarningEvent(this.props.applicationData.resources));
                return;
            }
            this.setState({
                currentState: 1 /* Scanning */,
                manualEntry: false,
                packIdentifier: new PackIdentifier_1.PackIdentifier(),
                availableActions: [],
                selectedAction: Types_2.PackAction.Verify
            }, function () {
                _this.parsePackData(JSON.stringify({ ScannedData: scannedString, CalibrationData: _this.props.applicationData.calibrationData }));
            });
        }
    };
    Safe.prototype.render = function () {
        var _this = this;
        return (React.createElement(Components_2.DashboardPage, { content: React.createElement("div", null,
                this.props.applicationData.apiProvider == "Ssr" && React.createElement(Components_1.DataEntryModeToggle, { onChange: this.dataEntryModeToggleHandler, manualEntry: this.state.manualEntry, resources: this.props.applicationData.resources }),
                React.createElement(Components_1.SafeForm, { manualEntry: this.state.manualEntry, onChangeHandler: this.manualInputOnChangeHandler, currentState: this.state.currentState, packIdentifier: this.state.packIdentifier, resources: this.props.applicationData.resources }),
                this.state.currentState === 4 /* Result */ &&
                    React.createElement(Components_2.SinglePackResponse, { result: this.state.result, resources: this.props.applicationData.resources, showHelpLink: this.props.applicationData.showHelpLink, packIdentifier: this.state.packIdentifier })), actions: !Array.isNullOrEmpty(this.state.availableActions) &&
                React.createElement("div", null, this.state.availableActions.map(function (action) {
                    return React.createElement(Components_2.ActionButton, { key: action.value, action: action, onClick: function () { _this.actionButtonOnClick(action); }, active: _this.state.selectedAction == action });
                })), placeholder: this.props.applicationData.resources.ActionsWillAppear_Single, title: this.props.applicationData.resources.PackDetails, resources: this.props.applicationData.resources }));
    };
    return Safe;
}(React.Component));
exports.Safe = Safe;
//# sourceMappingURL=Safe.js.map